export default [{
    path: '/test',
    name: 'test',
    component: () => import('../views/Test.vue'),
    meta: {
        isAuth: false
    }
},

{
    path: '/',
    name: 'index',
    component: () => import('../views/Index.vue'),
    meta: {
        isAuth: false
    },
    children: [{
        path: '/register',
        name: 'register',
        component: () => import('../views/customer/Register.vue'),
        meta: {
            isAuth: false
        }
    }, {
        path: '/forgetpwd',
        name: 'forgetpwd',
        component: () => import('../views/customer/ForgetPwd.vue'),
        meta: {
            isAuth: false
        }
    },{
        path: '/editpwd',
        name: 'editpwd',
        component: () => import('../views/customer/EditPwd.vue'),
        meta: {
            isAuth: false
        }
    },{
        path: '/login',
        name: 'login',
        component: () => import('../views/customer/Login.vue'),
        meta: {
            isAuth: false
        }
    }, {
        path: '/forget',
        name: 'forget',
        component: () => import('../views/customer/ForgetPwd.vue'),
        meta: {
            isAuth: false
        }
    }, {
        path: '',
        name: 'home',
        component: () => import('../views/Home.vue'),
        meta: {
            isAuth: false
        },
    },
    {
        path: '/about',
        name: 'about',
        component: () => import('../views/About.vue')
    },
    {
        path: '/bindwater',
        name: 'bindwater',
        component: () => import('../views/customer/BindWater.vue')
    },
    {
        path: '/bindcard',
        name: 'bindcard',
        component: () => import('../views/customer/BindCard.vue')
    },
    {
        path: '/order',
        name: 'order',
        component: () => import('../views/order/Order.vue'),
    },
    {
        path: '/orderdetail/:billNo',
        name: 'orderdetail',
        props: true,
        component: () => import('../views/order/OrderDetail.vue'),
    },
    {
        path: '/waterrecharge',
        name: 'waterrecharge',
        component: () => import('../views/waterfee/Recharge.vue'),
        meta: {
            isAuth: false
        },
    },
    {
        path: '/waterquery',
        name: 'waterquery',
        component: () => import('../views/waterfee/Query.vue'),
        meta: {
            isAuth: false
        }
    },
    {
        path: '/waterinfo',
        name: 'waterinfo',
        component: () => import('../views/waterfee/Info.vue'),
        meta: {
            isAuth: false
        }
    },
    {
        path: '/waterrecord',
        name: 'waterrecord',
        component: () => import('../views/waterfee/Record.vue'),
        meta: {
            isAuth: false
        }
    },
    {
        path: '/waterresult',
        name: 'waterresult',
        component: () => import('../views/waterfee/WaterResult.vue')
    },
    {
        path: '/hosregisterdept',
        name: 'hosregisterdept',
        component: () => import('../views/hospital/RegisterDept.vue'),
        meta: {
            isAuth: false
        }
    },
    {
        path: '/hosregisterdoctor/:noType/:orgCode/:deptCode',
        name: 'hosregisterdoctor',
        component: () => import('../views/hospital/RegisterDoctor.vue'),
        props: true,
        meta: {
            isAuth: false
        }
    },
    {
        path: '/hosregisterconfirmation',
        name: 'hosregisterconfirmation',
        component: () => import('../views/hospital/RegisterConfirmation.vue'),
        props: true,
        meta: {
            isAuth: false
        }
    },
    {
        path: '/hosregisterSuccess/:billNo',
        name: 'hosregisterSuccess',
        component: () => import('../views/hospital/RegisterSuccess.vue'),
        props: true
    },
    {
        path: '/hosreservedept',
        name: 'hosreservedept',
        component: () => import('../views/hospital/ReserveRegisterDept.vue'),
        meta: {
            isAuth: false
        }
    },
    {
        path: '/hosreservedoctor/:orgCode/:deptCode',
        name: 'hosreservedoctor',
        component: () => import('../views/hospital/ReserveRegisterDoctor.vue'),
        props: true,
        meta: {
            isAuth: false
        }
    },
    {
        path: '/hosreserveconfirmation',
        name: 'hosreserveconfirmation',
        component: () => import('../views/hospital/ReserveRegisterConfirmation.vue'),
        props: true,
        meta: {
            isAuth: false
        }
    },
    {
        path: '/reserveRegisterSuccess/:billNo',
        name: 'reserveRegisterSuccess',
        component: () => import('../views/hospital/ReserveRegisterSuccess.vue'),
        props: true
    },
    {
        path: '/hosregisterrecord',
        name: 'hosregisterrecord',
        component: () => import('../views/hospital/RegisterRecord.vue')
    },
    {
        path: '/providentquery',
        name: 'providentquery',
        component: () => import('../views/provident/Query.vue'),
        meta: {
            isAuth: false
        }
    },
    {
        path: '/providentqueryinfo',
        name: 'providentqueryinfo',
        component: () => import('../views/provident/QueryInfo.vue')
    },
    {
        path: '/providentquerydetail',
        name: 'providentquerydetail',
        component: () => import('../views/provident/QueryDetail.vue')
    },
    {
        path: '/startpay',
        name: 'startpay',
        props: true,
        component: () => import('../views/pay/StartPay.vue')
    },
    {
        path: '/payresult/',
        name: 'payresult',
        component: () => import('../views/pay/PayResult.vue')
    }
    ]
}
]